module.exports = __webpack_public_path__ + "static/media/testimonial_bg.f8f20a3f.jpg";